import { Flex, Box } from "@chakra-ui/layout";
import ContentItem from "components/ContentItem/ContentItem";
import { RetencaoImpostoItem } from "core/features/conta/typings/index";
import moment from "moment";
import { formatMoney } from "infra/helpers/number";
import colors from "core/resources/theme/colors";
import { Row, Col } from "antd";

export interface CardRetencaoImpostoProps {
  item: RetencaoImpostoItem;
}

export default function CardRetencaoImposto({
  item,
}: CardRetencaoImpostoProps) {
  return (
    <Flex
      border={`solid 1px ${colors.gray50}`}
      rounded={8}
      px={4}
      py={2}
      mb={2}
      w="100%"
    >
      <Box w="100%" as={Row} gutter={16}>
        <Box as={Col} xs={12}>
          <ContentItem
            titulo="Imposto"
            descricao={`(${item.imposto?.aliquota}%) - ${item.imposto?.nome}`}
            descricaoFontSize={"18px"}
          />
        </Box>
        <Box as={Col} xs={8}>
          <ContentItem
            titulo="Valor"
            descricao={formatMoney(item.valor)}
            descricaoFontSize={"18px"}
          />
        </Box>
        <Box as={Col} xs={4}>
          <ContentItem
            titulo="Vencimento"
            descricao={moment(item.dataVencimento).format("DD/MM/YYYY")}
            descricaoFontSize={"18px"}
          />
        </Box>
      </Box>
    </Flex>
  );
}
